import { ChangeDetectorRef, Component, ElementRef, HostBinding, Inject, OnInit, TemplateRef, ViewChild, ViewContainerRef } from '@angular/core'
import { HttpClient } from '@angular/common/http'
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog'
import { IconComponent } from 'src/app/elements/icon/icon.component'
import { DomPortalOutlet, TemplatePortal } from '@angular/cdk/portal'
import { LoaderComponent } from 'src/app/elements/loader/loader.component'

@Component({
  standalone: true,
  selector: 'app-popup',
  templateUrl: './popup.component.html',
  styleUrl: './popup.component.sass',
  imports: [
    IconComponent,
    LoaderComponent,
  ],
})
export class PopupComponent implements OnInit {
  @HostBinding('class.e--loading') protected loading: boolean = true
  @ViewChild('close') closeTmpl!: TemplateRef<any>
  @ViewChild('content') contentTmpl!: ElementRef<HTMLDivElement>

  constructor(
    @Inject(MAT_DIALOG_DATA) protected data: { url: string },
    protected http: HttpClient,
    protected dialogRef: MatDialogRef<PopupComponent>,
    protected cdr: ChangeDetectorRef,
    protected viewContainerRef: ViewContainerRef,
  ) {}

  ngOnInit(): void {
    this.loadExternalHtml()
  }

  loadExternalHtml(): void {
    this.http.get(this.data.url, { responseType: 'text' }).subscribe({
      next: (response: string) => {
        this.render(response)
      },
      error: (err) => {
        this.render(err.message)
      },
    })
  }

  protected render (content: string) {
    this.loading = false
    this.cdr.detectChanges()

    const contentEl = this.contentTmpl.nativeElement
    contentEl.innerHTML = content

    new DomPortalOutlet(
      contentEl.querySelector('.ed-close') as HTMLDivElement,
    ).attach(new TemplatePortal(this.closeTmpl, this.viewContainerRef))
  }

  closeDialog(): void {
    this.dialogRef.close();
  }
}
